module.exports = __webpack_public_path__ + "static/business_kv-37c5c3a022c7c3e6ca40023435eb8f2c.jpg";